import { render, staticRenderFns } from "./poolTransactions.vue?vue&type=template&id=1e6388a4&scoped=true"
import script from "./poolTransactions.vue?vue&type=script&lang=js"
export * from "./poolTransactions.vue?vue&type=script&lang=js"
import style0 from "./poolTransactions.vue?vue&type=style&index=0&id=1e6388a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6388a4",
  null
  
)

export default component.exports